import JSEncrypt from 'jsencrypt'
// --- 密钥配置 (此处为测试用的 1024位 密钥对) ---
// 前端需要的公钥
const PUBLIC_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDot50nyJ9NafNg26aYqouzaWevi0li3S+eI0uy6YyiRYPmuKF/Emg/iSi0/BHy3MK5BtFsXmWaJoIDvKOg8z8OkriRG7fMIQWcfs12EPpqGsZ30EsYpcrV1XEQXW17jAsR8WdzJvXHoUhZ0FVX72823se4rzlllOG3ebpEierRXwIDAQAB'

/**
 * RSA 加密方法 (使用公钥)
 * @param {string} text - 需要加密的明文
 * @returns {string|boolean} - 加密后的 Base64 字符串，失败返回 false
 */
export const encryptRSA = (text) => {
  if (!text) return ''
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(PUBLIC_KEY)
  return encryptor.encrypt(text)
}
